import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import _ from 'lodash';
import Colors from '../colors';
import Spacer from '../spacer';
import Text from '../text';
import BreakdownRow from '../breakdown-row';
import DividerLine from '../divider-line';
import Status from '../status';
import DocumentLink from '../document-link';
import Icon from '../icon';
const DPD_GRACE_PERIOD = 30;
const STATUS = {
  processing: 'information',
  disbursed: 'success',
  completed: 'success',
  cancelled: 'neutral',
  failed: 'error'
};
const StyledContainer = styled.View`
  background-color: ${Colors.white};
  border: 1px solid ${Colors.lightGray300};
  border-radius: 4px;
  padding: 16px;
`;
const StyledContractToggle = styled.Pressable`
  flex-direction: row;
  align-items: center;
`;
export default function Contract(props) {
  const status = Object.keys(STATUS).includes(props.status) ? props.status : Contract.defaultProps.status;
  const [showContracts, setShowContracts] = useState(false);
  return /*#__PURE__*/React.createElement(StyledContainer, null, /*#__PURE__*/React.createElement(BreakdownRow, {
    type: "fees",
    label: "Status",
    tooltip: {
      title: 'Salary advance status',
      content: props.tooltipContent.status,
      contentMaxWidth: 296,
      textWidth: 230
    }
  }, /*#__PURE__*/React.createElement(Status, {
    type: STATUS[status]
  }, _.startCase(status))), /*#__PURE__*/React.createElement(Spacer, {
    size: "f16",
    height: true
  }), /*#__PURE__*/React.createElement(BreakdownRow, {
    type: "default",
    label: "Amount Advanced",
    amount: props.amount
  }), /*#__PURE__*/React.createElement(Spacer, {
    size: "f16",
    height: true
  }), /*#__PURE__*/React.createElement(BreakdownRow, {
    type: "fees",
    label: "Total Fees",
    amount: props.fees,
    tooltip: {
      title: '',
      content: props.tooltipContent.fees
    }
  }), (props.dpd > DPD_GRACE_PERIOD || props.penalties > 0) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
    size: "f16",
    height: true
  }), /*#__PURE__*/React.createElement(BreakdownRow, {
    type: "default",
    label: "Total Penalties",
    amount: props.penalties
  })), props.discounts > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
    size: "f16",
    height: true
  }), /*#__PURE__*/React.createElement(BreakdownRow, {
    type: "discount",
    label: "Total Discounts",
    amount: props.discounts
  })), /*#__PURE__*/React.createElement(Spacer, {
    size: "f16",
    height: true
  }), /*#__PURE__*/React.createElement(BreakdownRow, {
    type: "default",
    label: "Payment Terms"
  }, /*#__PURE__*/React.createElement(Text.BodySmall, {
    color: Colors.gray400
  }, props.terms, ' ', "Term", props.terms > 1 && 's')), /*#__PURE__*/React.createElement(Spacer, {
    size: "f16",
    height: true
  }), /*#__PURE__*/React.createElement(BreakdownRow, {
    type: "total",
    label: "Total Amount Due",
    amount: props.total
  }), /*#__PURE__*/React.createElement(Spacer, {
    size: "f16",
    height: true
  }), /*#__PURE__*/React.createElement(DividerLine, null), /*#__PURE__*/React.createElement(Spacer, {
    size: "f16",
    height: true
  }), /*#__PURE__*/React.createElement(BreakdownRow, {
    type: "default",
    label: "Signed Contract"
  }, /*#__PURE__*/React.createElement(StyledContractToggle, {
    onPress: () => setShowContracts(!showContracts)
  }, /*#__PURE__*/React.createElement(Text.BodySmall, {
    color: Colors.gray600
  }, "View Contracts"), /*#__PURE__*/React.createElement(Spacer, {
    size: "f20",
    width: true
  }), /*#__PURE__*/React.createElement(Icon.MaterialIcons, {
    name: showContracts ? 'expand-less' : 'expand-more',
    size: 24,
    color: Colors.gray600
  }))), showContracts && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
    size: "f16",
    height: true
  }), props.contracts.map((contract, index) => {
    const isLast = props.contracts.length - 1 === index;
    return /*#__PURE__*/React.createElement(Fragment, {
      key: index
    }, /*#__PURE__*/React.createElement(DocumentLink, {
      name: contract.name,
      url: contract.url
    }), !isLast && /*#__PURE__*/React.createElement(Spacer, {
      size: "f12",
      height: true
    }));
  })));
}
Contract.defaultProps = {
  status: 'processing',
  amount: 0,
  fees: 0,
  penalties: 0,
  discounts: 0,
  terms: 0,
  total: 0,
  dpd: 0,
  contracts: [],
  tooltipContent: {
    status: '',
    fees: ''
  }
};
Contract.propTypes = {
  status: PropTypes.oneOf(Object.keys(STATUS)),
  amount: PropTypes.number,
  fees: PropTypes.number,
  penalties: PropTypes.number,
  discounts: PropTypes.number,
  terms: PropTypes.number,
  total: PropTypes.number,
  dpd: PropTypes.number,
  contracts: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    url: PropTypes.string
  })),
  tooltipContent: PropTypes.shape({
    status: PropTypes.string,
    fees: PropTypes.string
  })
};
//# sourceMappingURL=contract.js.map